<!--
 * @Author: xuesong
 * @Date: 2021-04-26 19:18:04
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-06-28 11:54:00
 * @Description: 常用语句
-->
<template>
  <div>
    <el-popover placement="top-start"   :width="popverWidth" trigger="manual" v-model="visiblePop">
      <div class="isOveruse">
        <!-- 常用语及常见问题 -->
        <div class="isOveruse-head">
          <!--  @tab-click="handleClick" -->
          <el-tabs v-model="activeName">
            <el-tab-pane label="常用语" name="oversuse" class="oversuse">
              <div class="isOveruse-header">
                <div class="header-input">
                  <el-input size="small" placeholder="请输入您要搜索的内容" v-model="oversuseInput" @change="changeInput">
                    <!-- icon="el-icon-search" -->
                    <el-button slot="append">搜索</el-button>
                  </el-input>
                </div>
                <div class="header-button">
                  <el-button type="primary" size="small" icon="el-icon-plus" @click="addSentence">新增回复标语</el-button>
                </div>
                <div class="header-close" @click="closePopver"><i class="el-icon-close" style="font-size:25px"></i>
                </div>
              </div>
              <div class="Overuse">
                <el-tree :data="popoverList" node-key="id" default-expand-all :check-strictly="true" draggable
                  :allow-drop="allowDrop" :props="defaultPropsMenu" :expand-on-click-node="false" @node-drop='dropOver'
                  @node-click='sendOveruse'>
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span class="tree-msg" v-if="data.id != showUpdateId">{{ node.label }}</span>
                    <el-input style="width: 571px" v-model="data.content" v-if="data.id == showUpdateId" />
                    <span>
                      <el-button type="text" size="mini" v-if="data.id != showUpdateId"
                        @click="updateSentence(node,data)">
                        编辑
                      </el-button>
                      <el-button type="text" size="mini" v-if="data.id == showUpdateId"
                        @click="updateSaveSentence(node,data)">
                        保存
                      </el-button>
                      <el-button type="text" size="mini" @click.stop="deleteSentence(node,data)">
                        删除
                      </el-button>
                    </span>
                  </span>
                </el-tree>
                <!-- <div
                  class="overuse-item"
                  v-for="(item, index) in popoverList"
                  :key="index"
                >
                  <div class="item">
                    <div style=" width: 571px">
                      <span class="item-content"
                        
                        v-if="item.id != showUpdateId"
                        @click="sendOveruse(item)"
                        >{{ item.content }}</span
                      >
                      <el-input
                        style="width: 571px"
                        v-model="item.content"
                        v-if="item.id == showUpdateId"
                      />
                    </div>
                    <div>
                      <span
                        class="item-edit"
                        v-if="item.id != showUpdateId"
                        @click="updateSentence(item)"
                        >编辑</span
                      >
                      <span
                        class="item-edit"
                        v-if="item.id == showUpdateId"
                        @click="updateSaveSentence(item)"
                        >保存</span
                      >

                      <span class="item-delete" @click="deleteSentence(item)"
                        >删除</span
                      >
                    </div>
                  </div>
                </div> -->
              </div>

              <div v-if="showAdd" style="display: flex;
                align-items: center;
                line-height: 32px;
                font-size: 12px;
                cursor: pointer;
                ">
                <el-input style=" width: 571px" size="small" placeholder="" v-model="addInputValue" />
                <div style="color: #1a7bfc; margin-left: 40px;
                " @click="saveSentence">
                  <span style="color: #1a7bfc; 
                ">保存</span>
                  <span style="margin-left: 30px;color: #999;" @click="cancelAddSave">取消</span>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="常见问题" name="overquestion" class="overquestion"
              v-if="this.$store.state.userPlatForm === 'platForm'">
              <div class="over-question">
                <el-scrollbar style="height: calc(100% - 32px)">
                  <ul v-if="questionAnsData.length > 0">
                    <li v-for="(item, key) in questionAnsData" :key="key" @click="questionSelect(item)">
                      <p>
                        <img src="@/assets/images/q@3x.png" />
                        <span v-html="item.question" class="q"></span>
                      </p>
                      <p>
                        <img src="@/assets/images/a@3x.png" />
                        <span class="a">{{ item.answer }}</span>
                      </p>
                    </li>
                  </ul>
                  <div v-else class="overquestion-empty">暂无数据</div>
                </el-scrollbar>
                <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="total"
                  :hide-on-single-page="true" style="text-align: center" :page-sizes="[10, 20, 30, 40, 50, 100]"
                  :page-size="questionParam.size" @current-change="pageChange" @size-change="pageSizeChange"
                  v-if="pages > 1">
                </el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
          <div class="search-right" v-if="activeName === 'overquestion'">
            <el-select v-model="questionParam.diseaseName" filterable remote reserve-keyword clearable value-key="id"
              size="small" placeholder="请输入病种" :remote-method="findIcdDiseaseByCondition" :loading="diseaseLoading"
              style="width: 146px" prefix-icon="el-icon-date" @change="diseaseChange">
              <el-option v-for="item in diseaseArr" :key="item.id" :label="item.suborderName" :value="item">
              </el-option>
            </el-select>
            <el-input size="small" placeholder="请输入内容" v-model="questionParam.conditionName" clearable
              style="width: 146px;margin-right: 10px"></el-input>
            <el-button type="primary" plain size="mini" @click="searchQuestionParam">搜索</el-button>
          </div>
        </div>
      </div>
      <div slot="reference" class="iconfont iconwenjuan" @click="closePopver" style="color: #666666;font-size: 25px">
      </div>
    </el-popover>
  </div>
</template>

<script>
import {
  apiCommonSetSort,
  getIMCommonQuestions,
  findIcdDiseaseByCondition
} from "../../api/crossApi";
export default {
  props: {
    // 传入的数据
    popoverList: {
      type: Array,
      default: []
    },

    // icon 的样式
    iconClass: {
      type: String,
      default: ""
    },
    popverWidth: {
      type: Number,
      default: 500
    },
    // 控制显示开关
    visiblePop: {
      type: Boolean,
      default: false
    },
    // 新增显示框
    showAdd: {
      type: Boolean,
      default: false
    },
    showUpdateId: {
      type: Object | String,
      default: () => {}
    }
  },
  data() {
    return {
      oversuseInput: "",
      addInputValue: "",
      activeName: "oversuse", // 默认常用语
      defaultPropsMenu: {
        label: "content"
      }, //改变权限树名字显示字段
      questionParam: {
        conditionName: "",
        diseaseId: "",
        diseaseName: "",
        current: 1,
        size: 10
      },
      diseaseArr: [], // 病种数组
      diseaseLoading: false,
      questionAnsData: [],
      pages: 1,
      total: 0
    };
  },
  watch: {
    popoverList(newValue, oldValue) {},
    visiblePop(val) {
      if (val) {
        this.getIMCommonQuestions();
        this.findIcdDiseaseByCondition(this.questionParam.diseaseName);
      } else {
        this.oversuseInput = "";
        this.questionParam.diseaseId = "";
        this.questionParam.diseaseName = "";
        this.questionParam.conditionName = "";
        this.activeName = "oversuse";
      }
    }
  },
  methods: { 
    // 关闭popver
    closePopver() {
      this.$emit("closePopver");
    },
    // 点击发送事件
    sendOveruse(data) {
      this.$emit("sendOveruse", data);
    },
    // 搜索常用语
    changeInput() {
      this.$emit("changeInput", this.oversuseInput);
    },
    // 新增常用语句
    addSentence() {
      this.oversuseInput = "";
      this.$emit("addSentence");
    },
    // 编辑常用语句
    updateSentence(node, data) {
      this.$emit("updateSentence", data);
    },
    // 删除常用语句
    deleteSentence(node, data) {
      this.$emit("deleteSentence", data);
    },
    saveSentence() {
      this.$emit("saveSentence", this.addInputValue);
      this.addInputValue = "";
    },
    updateSaveSentence(node, data) {
      this.$emit("updateSaveSentence", data);
    },
    // 取消保存
    cancelAddSave() {
      this.$emit("cancelAddSave");
    },
    //设置只能同级拖拽
    allowDrop(draggingNode, dropNode, type) {
      if (draggingNode.level === dropNode.level) {
        if (draggingNode.parent.id === dropNode.parent.id) {
          return type === "prev";
        }
      } else {
        // 不同级进行处理
      }
    },
    dropOver() {
      let updataForm = [];
      let sort = -1;
      this.popoverList.forEach(item => {
        item.sort = sort += 1;
        let obj = {
          id: item.id,
          sort: this.popoverList.length - item.sort,
          name: item.content
        };
        updataForm.push(obj);
      });
      apiCommonSetSort(updataForm).then(res => {});
    },
    // icd-10病种列表查询
    async findIcdDiseaseByCondition(query) {
      if (query !== "") {
        this.diseaseLoading = true;
        let { code, data } = await findIcdDiseaseByCondition({
          conditionName: query
        });
        if (code === 0) {
          this.diseaseLoading = false;
          this.diseaseArr = data.map(item => {
            return {
              ...item
            };
          });
        }
      } else {
        this.diseaseArr = [];
      }
    },
    diseaseChange(value) {
      this.questionParam.diseaseId = value.id;
      this.questionParam.diseaseName = value.suborderName;
    },
    // 问题选择
    questionSelect(item) {
      // 问题选择完毕关闭弹框将答案填充到文本输入框中
      this.$emit("sendOveruse", { content: item.answer });
    },
    // 搜索
    searchQuestionParam() {
      this.getIMCommonQuestions();
    },
    // 常见问题接口查询
    async getIMCommonQuestions() {
      let { code, data } = await getIMCommonQuestions(this.questionParam);
      if (code === 0) {
        // 判断有没有搜索条件
        this.pages = data.pages;
        this.total = data.total;
        if (
          !this.questionParam.conditionName &&
          !this.questionParam.diseaseId
        ) {
          this.questionAnsData = data.records.map(item => {
            return {
              ...item
            };
          });
        } else if (
          this.questionParam.conditionName &&
          !this.questionParam.diseaseId
        ) {
          this.questionAnsData = data.records.map(item => {
            item.question = item.question.replaceAll(
              this.questionParam.conditionName,
              `<span class="q-filter">${this.questionParam.conditionName}</span>`
            );
            return { ...item };
          });
        } else if (
          !this.questionParam.conditionName &&
          this.questionParam.diseaseId
        ) {
          this.questionAnsData = data.records.map(item => {
            item.question = item.question.replaceAll(
              this.questionParam.diseaseName,
              `<span class="q-filter">${this.questionParam.diseaseName}</span>`
            );
            return { ...item };
          });
        } else if (
          this.questionParam.conditionName &&
          this.questionParam.diseaseId
        ) {
          this.questionAnsData = data.records.map(item => {
            item.question1 = item.question.replaceAll(
              this.questionParam.diseaseName,
              `<span class="q-filter">${this.questionParam.diseaseName}</span>`
            );
            item.question = item.question1.replaceAll(
              this.questionParam.conditionName,
              `<span class="q-filter">${this.questionParam.conditionName}</span>`
            );
            return { ...item };
          });
        }
      }
    },
    // 分页切换
    pageChange(current) {
      this.questionParam.current = current;
      this.getIMCommonQuestions();
    },
    // pageSize切换
    pageSizeChange(size) {
      this.questionParam.current = 1;
      this.questionParam.size = size;
      this.getIMCommonQuestions();
    }
  }
};
</script>

<style lang="less" scoped>
.isOveruse {
  padding: 6px;
  .isOveruse-head {
    position: relative;
    .el-tabs {
      /deep/.el-tabs__nav-wrap::after {
        height: 0;
      }
      /deep/.el-tabs__header {
        margin: 0;
      }
      /deep/.el-tabs__content {
        margin-top: 8px;
        border-top: 0.5px solid #f0f0f0;
        padding-top: 10px;
        height: 450px;
      }
      .overquestion,
      .oversuse {
        height: 100%;
      }
      .over-question {
        height: 100%;
        .el-scrollbar {
          /deep/.el-scrollbar__wrap {
            overflow-x: hidden;
          }
        }
        ul {
          li {
            border-bottom: 0.5px solid #f0f0f0;
            padding: 10px;
            cursor: pointer;
            p {
              display: flex;
              img {
                width: 12px;
                height: 12px;
                margin-right: 10px;
                margin-top: 3px;
              }
              span {
                color: #666666;
                font-size: 12px;
              }
              .q {
                color: #333333;
                font-weight: 500;
                /deep/.q-filter {
                  color: #1a7bfc;
                }
              }
              &:last-child {
                margin-top: 8px;
                line-height: 20px;
              }
            }
            &:last-child {
              border-bottom: none;
            }
            &:hover {
              background: #eef5ff;
            }
          }
        }
        .overquestion-empty {
          color: #909399;
          text-align: center;
          margin-top: 20px;
        }
      }
    }
    .search-right {
      display: flex;
      position: absolute;
      top: 0;
      right: 0;
      .el-input {
        margin-left: 10px;
      }
    }
  }
  .isOveruse-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .header-input {
      margin-right: 20px;
      width: 389px;
    }

    .header-close {
      margin-left: auto;
      cursor: pointer;
    }
  }
  .Overuse {
    height: 350px;
    overflow-y: auto;
    /deep/ .overuse-item {
      margin-right: 5px;
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 32px;
        font-size: 12px;
        cursor: pointer;
        .item-content {
          display: block;
          width: 570px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .item-edit {
          color: #1a7bfc;
          margin-right: 30px;
        }
        .item-delete {
          color: #999;
        }
      }
    }
    .overuse-item:hover {
      color: #1a7bfc;
    }
  }
  .Overuse /deep/ .overuse-item-input {
    display: flex;
    align-items: center;
    line-height: 32px;
    font-size: 12px;
    cursor: pointer;
    margin-right: 5px;
    /deep/ .item-input {
      width: 571px !important;
    }
    .item-edit {
      color: #1a7bfc;
      margin-left: 44px;
    }
  }

  .Overuse::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .Overuse::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background-color: #1a7bfc;
  }
}
.box-icon {
  margin-top: 5px;
}
.custom-tree-node {
  display: flex;
  width: 96%;
  justify-content: space-between;
}

.tree-msg {
  display: inline-block;
  width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/deep/.is-leaf .el-tree-node__expand-icon .el-icon-caret-right {
  display: none !important;
}
</style>
